// Validates a National Provider Identifier per the CMS/NPPES rule: a 10-digit
// number whose last digit is a Luhn check digit computed over the constant
// prefix "80840" + the first 9 digits. Non-digits are stripped before checking.
const NPI_PREFIX = "80840";

export function isValidNpi(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10) return false;

  const base = NPI_PREFIX + digits.slice(0, 9);
  let sum = 0;
  let double = true; // rightmost base digit is doubled first (check digit sits to its right)
  for (let i = base.length - 1; i >= 0; i--) {
    let d = base.charCodeAt(i) - 48;
    if (double) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    double = !double;
  }
  const check = (10 - (sum % 10)) % 10;
  return check === digits.charCodeAt(9) - 48;
}
